import React from 'react';
import moment from 'moment';
import { TextToolTip } from 'components';
import { formatAMPM } from 'utils';

const APPT_DATE_FORMAT = 'MM/DD/YYYY';

const renderApptDate = (date) => (date ? moment.utc(date).format(APPT_DATE_FORMAT) : '--');

const ApptTextCell = ({ value }) => (
    <TextToolTip
        classNameWrapper={'signature-request-appts-cell-wrap'}
        classNameText={'signature-request-appts-cell'}
        text={value}
        content={value}
    />
);

export const SIGNATURE_TAB = {
    DRAW: 'Draw',
    TYPE: 'Type',
};

export const SIGNATURE_TABS_LABELS = [{ label: SIGNATURE_TAB.DRAW }, { label: SIGNATURE_TAB.TYPE }];

export const getInfoBarCells = (request) => [
    { label: 'Clinic:', value: request?.clinicName || '--' },
    { label: 'Client:', value: request?.clientName || '--' },
    { label: 'Total Appointments:', value: String(request?.appointmentCount ?? 0) },
];

export const getSubmittedDetails = (request) => [
    { label: 'Client', value: request?.clientName || '--' },
    { label: 'Clinic', value: request?.clinicName || '--' },
    { label: 'Appointments', value: String(request?.appointmentCount ?? 0) },
    { label: 'Date range', value: request?.dateRange || '--' },
];

export const APPT_TABLE_COLUMNS = [
    {
        key: 'date',
        title: 'Date',
        render: (appt) => <ApptTextCell value={renderApptDate(appt?.date)} />,
    },
    {
        key: 'time',
        title: 'Time',
        render: (appt) => <ApptTextCell value={`${formatAMPM(appt?.startTime)} – ${formatAMPM(appt?.endTime)}`} />,
    },
    {
        key: 'service',
        title: 'Service',
        render: (appt) => <ApptTextCell value={appt?.cptCode || appt?.serviceName || '--'} />,
    },
    {
        key: 'provider',
        title: 'Provider',
        render: (appt) => <ApptTextCell value={appt?.providerName || '--'} />,
    },
];

export const APPT_PREVIEW_COUNT = 5;

export const SIGNATURE_CANVAS_HEIGHT = 150;

export const TYPED_SIGNATURE_FONT = "italic 40px 'Dancing Script', 'Brush Script MT', cursive";

export const SIGNATURE_INK_COLOR = '#172B4D';

export const SIGNATURE_FILE_NAME = 'signature.png';

export const SIGNATURE_REQUEST_ERROR = {
    EXPIRED: 'Signature request link has expired',
    NOT_FOUND: 'Signature request not found or invalid',
    INVALID_TYPE: 'Invalid token type',
    NO_TOKEN: 'signature-token header was not set',
    ALREADY_PREFIX: 'Signature request is already',
};
